export enum StorageDestinationType {
  NEAREST_WAREHOUSE = "NEAREST_WAREHOUSE",
  SPECIFIC_WAREHOUSE = "SPECIFIC_WAREHOUSE",
}
